import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AuthRoutingModule } from './auth-routing.module';
import { LoginPageComponent } from './pages/login-page/login-page.component';
import { SharedModule } from '../shared/shared.module';
import { MaterialModule } from '../material.module';
import { ReactiveFormsModule } from '@angular/forms';
import { NgxsModule } from '@ngxs/store';
import { AuthState } from './state/auth/auth.state';

import { SocialLoginModule, AuthServiceConfig, FacebookLoginProvider } from 'angularx-social-login';
import { GoogleLoginProvider } from 'angularx-social-login';
import { LoginMasterComponent } from './pages/login-master/login-master.component';
import { ResetPageComponent } from './pages/reset-page/reset-page.component';
import { SignUpPageComponent } from './pages/sign-up-page/sign-up-page.component';

import { environment } from 'src/environments/environment';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { LocaleConfigModule } from '../locale-config.module';
import { LoginArtComponent } from './components/login-art/login-art.component';
 
const config = new AuthServiceConfig([
  {
    id: GoogleLoginProvider.PROVIDER_ID,
    provider: new GoogleLoginProvider(environment.googleAuthKey)
  },
  {
    id: FacebookLoginProvider.PROVIDER_ID,
    provider: new FacebookLoginProvider(environment.facebookAuthKey)
  }
]);
 
export function provideConfig() {
  return config;
}


@NgModule({
  imports: [
    NgxsModule.forFeature([
      AuthState
    ]),
    SocialLoginModule,
    ReactiveFormsModule,
    MaterialModule,
    CommonModule,
    SharedModule,
    AuthRoutingModule,
    FontAwesomeModule,
    LocaleConfigModule
  ],
  providers: [
    {
      provide: AuthServiceConfig,
      useFactory: provideConfig
    }
  ],
  declarations: [
    LoginPageComponent, 
    LoginMasterComponent, 
    ResetPageComponent, 
    SignUpPageComponent, LoginArtComponent
  ],
  exports: [
  ],
  entryComponents: [
  ]
})
export class AuthModule { }
